import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box, Stack, Typography } from '@mui/material';

import type { ManualApprovalState } from '../types';
import type { DealOptionsInclusionsDealRow } from '../utils';

import DealCard from './DealCard';
import HiddenApprovedFooter from './HiddenApprovedFooter';
import ReportCard from './ReportCard';

interface Props {
  dealRows: Array<DealOptionsInclusionsDealRow>;
  hiddenApprovedCount: number;
  manualApprovals: ManualApprovalState;
  showAutoApproved: boolean;
  onApprovalChange: (rowId: string) => void;
  onUnapprovalChange: (rowId: string) => void;
}

export default function DealOptionsInclusionsReportCard({
  dealRows,
  hiddenApprovedCount,
  manualApprovals,
  showAutoApproved,
  onApprovalChange,
  onUnapprovalChange,
}: Props) {
  return (
    <ReportCard>
      <Box sx={{ p: 2 }}>
        <Alert severity="info" icon={<InfoOutlinedIcon fontSize="small" />} sx={{ mb: 2 }}>
          <strong>RRP comparison:</strong> the dot is{' '}
          <Box component="span" sx={{ color: 'success.main', fontWeight: 700 }}>
            green
          </Box>{' '}
          when <strong>Inclusion Asset Value</strong> exactly equals <strong>Deal Option Inclusion RRP</strong>. It
          turns{' '}
          <Box component="span" sx={{ color: 'warning.main', fontWeight: 700 }}>
            orange
          </Box>{' '}
          when those values differ.
        </Alert>

        {dealRows.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
            No deal options found.
          </Typography>
        ) : (
          <Stack spacing={2}>
            {dealRows.map((deal) => (
              <DealCard
                key={deal.id}
                deal={deal}
                manualApprovals={manualApprovals}
                showAutoApproved={showAutoApproved}
                onApprovalChange={onApprovalChange}
                onUnapprovalChange={onUnapprovalChange}
              />
            ))}
          </Stack>
        )}
      </Box>
      <HiddenApprovedFooter count={hiddenApprovedCount} noun="inclusion row" showAutoApproved={showAutoApproved} />
    </ReportCard>
  );
}
